<app-spinner-overlay></app-spinner-overlay>

<div class="titolo-pagina" style="padding-top: 20px">
  <div class="titolo-diag">Tematica - {{ data.domandaTematica }}</div>

  <div class="descrizione-diag">
    Seleziona i temi, sottotemi e i relativi sotto-sottotemi da legare alla tematica.
  </div>
</div>

<div appFormContainer [larghezza]="2" style="padding-top: 10px; padding-bottom: 15px; flex: 1">
  <div appFormElement [larghezza]="2" [riempi]="true" class="list-container">
    <!-- ---------- TEMA ------------- -->
    <div class="cont-titolo">
      <mat-checkbox (change)="onChangeTema($event)" [checked]="esrs?.selected">
        <strong class="truncate" style="font-size: 13px">
          {{ esrs?.nomeBreve }} {{ esrs?.descrizione ?? ' - ' + esrs?.descrizione }}
        </strong>
      </mat-checkbox>
    </div>

    <!-- ---------- SOTTO-TEMA ------------- -->
    <div class="container-esrs">
      <ng-scrollbar>
        @for (sottoTema of esrs?.sottoTemi; track sottoTema.id) {
          <mat-accordion #selPanel="matAccordion" multi>
            <mat-expansion-panel
              [hideToggle]="!sottoTema.sottoTemi.length"
              style="background-color: #f7f7f7 !important"
              [expanded]="sottoTema.sottoTemi.length > 0"
              [disabled]="!sottoTema.sottoTemi.length"
            >
              <mat-expansion-panel-header>
                <mat-panel-title>
                  <mat-checkbox
                    (click)="$event.stopPropagation()"
                    [checked]="sottoTema.selected"
                    (change)="onChangeSottoTema($event, sottoTema)"
                  >
                    <mat-label class="truncate" style="font-weight: 500; font-size: 13px">
                      {{ sottoTema?.nomeBreve }}
                      {{ sottoTema?.descrizione ?? ' - ' + sottoTema.descrizione }}
                    </mat-label>
                  </mat-checkbox>
                </mat-panel-title>
              </mat-expansion-panel-header>

              <!-- ---------- SOTTO-SOTTO-TEMA ------------- -->
              <div class="cnt-sotto-temi">
                @for (
                  sottoSottoTema of sottoTema?.sottoTemi;
                  track sottoSottoTema.id;
                  let lastIdx = $last
                ) {
                  <div class="cnt-sotto-sotto-temi">
                    <mat-checkbox
                      color="primary"
                      [checked]="sottoSottoTema.selected"
                      (click)="$event.stopPropagation()"
                      (change)="onChangeSottoSottoTema($event, sottoTema, sottoSottoTema)"
                    >
                      <mat-label class="truncate" style="font-size: 12px">
                        {{ sottoSottoTema?.nomeBreve }}
                        {{ sottoSottoTema?.descrizione ?? ' - ' + sottoSottoTema.descrizione }}
                      </mat-label>
                    </mat-checkbox>
                  </div>
                }
              </div>
            </mat-expansion-panel>
          </mat-accordion>
        }
      </ng-scrollbar>
    </div>
  </div>
</div>

<div mat-dialog-actions class="dialog-footer-cont">
  <div>
    <button mat-dialog-close mat-flat-button color="accent" class="accent-button">Indietro</button>
  </div>
  <div>
    <button mat-flat-button color="primary" (click)="conferma()" class="primary-button">
      Conferma
    </button>
  </div>
</div>
